import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
const WholesalerMenu = () => {
  const x = 0;
  const [contentNav, setContentNav] = useState("");
  useEffect(() => {
    //
    getSet();
    // getContentNavData();
  }, []);
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);
  const getContentNavData = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_content_nav_data", {
        params: {
          name: "Wholesale", //
          content_nav: get_cookies("content.nav.access"),
        },
      })
      .then(function (res) {
        // console.log("res", res);
        setContentNav(res.data.data);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };
  const getSet = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "wholesale", {
        params: {
          hqidno: get_cookies("branchidno"),
        },
      })
      .then(function (res) {
        // console.log("res", res);
        const newObject = { package_type: "Transaction" };
        setContentNav([...res.data.data.info, newObject]);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };
  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <h2 className="header-title">Wholesale Set</h2>
      </div>
      <div className="page-container">
        {console.log("con", contentNav)}
        <Grid container spacing={2}>
          {contentNav ? (
            contentNav.map((item) => {
              return item.package_type !== "Transaction" ? (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  className="app-card-container"
                  key={item.package_name}
                  style={{
                    "--cardBorderColor": "#339933",
                  }}
                >
                  {/* <NavLink
                    to={
                      item.cn_url == "/Wholesale/transaction_history"
                        ? "/wholesale-transaction-history/"
                        : "/Wholesale-set/" + item.cn_name + "/" + item.cn_name
                    }
                    key={item.id}
                  >
                    <div className="app-card">{item.cn_name}</div>
                  </NavLink> */}
                  <NavLink
                    to={{
                      pathname: `/Wholesale-set/${item.package_name}`,
                      state: { item }, // pass the entire item object
                    }}
                    key={item.package_name}
                  >
                    <div className="app-card">
                      {item.package_type} - {item.package_name}
                    </div>
                  </NavLink>
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  className="app-card-container"
                  key={item.id}
                  style={{
                    "--cardBorderColor": "#339933",
                  }}
                >
                  <NavLink to={"/wholesale-transaction-history/"} key={item.id}>
                    <div className="app-card">
                      {"Wholesale Set Transaction History"}
                    </div>
                  </NavLink>
                </Grid>
              );
            })
          ) : (
            <Preloader />
          )}
        </Grid>
      </div>
    </div>
  );
};

export default WholesalerMenu;
